import { icons } from './constant';

// ==============================|| CUSTOMER MENU ITEMS ||============================== //

const other = {
	id: 'other',
	title: 'Other',
	type: 'collapse',
	icon: icons.IconCustomer,
	children: [
		{
			id: 'credentials',
			title: 'Credentials',
			type: 'item',
			url: '/credentials',
			icon: icons.IconDesignation,
			breadcrumbs: true,
		},
		{
			id: 'ipConfiguration',
			title: 'IP Configuration',
			type: 'item',
			url: '/ipConfigurations',
			icon: icons.IconDesignation,
			breadcrumbs: true,
		},
		{
			id: 'caseHistoryActions',
			title: 'Case History Actions',
			type: 'item',
			url: '/caseHistoryActions',
			icon: icons.IconDesignation,
			breadcrumbs: true,
		},
		{
			id: 'globalSwitchConfigurations',
			title: 'Global Switch Configuration',
			type: 'item',
			url: '/globalSwitchConfigurations',
			icon: icons.IconDesignation,
			breadcrumbs: true,
		},
	],
};

export default other;
